import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    closeId: String,
    openId: String
  }

  closeAndOpen() {
    this.#setModalState(this.closeIdValue, false)
    this.#setModalState(this.openIdValue, true)
  }

  close() {
    this.#setModalState(this.closeIdValue, false)
  }

  #setModalState(modalId, checked) {
    if (modalId) {
      const modal = document.getElementById(modalId)
      if (modal) modal.checked = checked
    }
  }
} 